import { ModalFooterButton } from '@/components/Modal'
import { useTexts } from '../../../useTexts'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useController } from '../../../hooks/useController'

export function ButtonApplyChanges() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    data: { inputError },
  } = useController()

  return (
    <ModalFooterButton
      testid="modal-primary-button"
      title={texts.buttonApplyChanges}
      variant="contained"
      onClick={handlers.onApplyChangesButtonClick}
      disabled={!!inputError.hasError}
    >
      {texts.buttonApplyChanges}
    </ModalFooterButton>
  )
}
